export const CountryList = [
    "AFGHANISTAN",
    "ALBANIA",
    "ALGERIA",
    "AMERICAN SAMOA",
    "ANDORRA",
    "ANGOLA",
    "ANGUILLA",
    "ANTARCTICA",
    "ANTIGUA AND BARBUDA",
    "ARGENTINA",
    "ARMENIA",
    "ARUBA",
    "AUSTRALIA",
    "AUSTRIA",
    "AZERBAIJAN",
    "BAHAMAS",
    "BAHRAIN",
    "BANGLADESH",
    "BARBADOS",
    "BELARUS",
    "BELGIUM",
    "BELIZE",
    "BENIN",
    "BERMUDA",
    "BHUTAN",
    "BOLIVIA",
    "BOSNIA-HERZEGOVINA",
    "BOTSWANA",
    "BOUVET ISLAND",
    "BRAZIL",
    "BRITISH INDIAN OCEAN TERRITORY",
    "BRUNEI DARUSSALAM",
    "BULGARIA",
    "BURKINA FASO",
    "BURUNDI",
    "CAMBODIA",
    "CAMEROON",
    "CANADA",
    "CAPE VERDE",
    "CAYMAN ISLANDS",
    "CENTRAL AFRICAN REPUBLIC",
    "CHAD",
    "CHILE",
    "CHINA",
    "CHRISTMAS ISLAND",
    "COCOS (KEELING) ISLANDS",
    "COLOMBIA",
    "COMOROS",
    "CONGO",
    "CONGO, DEM. REPUBLIC",
    "COOK ISLANDS",
    "COSTA RICA",
    "CROATIA",
    "CUBA",
    "CYPRUS",
    "CZECH REP.",
    "DENMARK",
    "DJIBOUTI",
    "DOMINICA",
    "DOMINICAN REPUBLIC",
    "ECUADOR",
    "EGYPT",
    "EL SALVADOR",
    "EQUATORIAL GUINEA",
    "ERITREA",
    "ESTONIA",
    "ETHIOPIA",
    "EUROPEAN UNION",
    "FALKLAND ISLANDS (MALVINAS)",
    "FAROE ISLANDS",
    "FIJI",
    "FINLAND",
    "FRANCE",
    "FRENCH GUIANA",
    "GABON",
    "GAMBIA",
    "GEORGIA",
    "GERMANY",
    "GHANA",
    "GIBRALTAR",
    "GREAT BRITAIN",
    "GREECE",
    "GREENLAND",
    "GRENADA",
    "GUADELOUPE (FRENCH)",
    "GUAM (USA)",
    "GUATEMALA",
    "GUERNSEY",
    "GUINEA",
    "GUINEA BISSAU",
    "GUYANA",
    "HAITI",
    "HEARD ISLAND AND MCDONALD ISLANDS",
    "HONDURAS",
    "HONG KONG",
    "HUNGARY",
    "ICELAND",
    "INDIA",
    "INDONESIA",
    "IRAN",
    "IRAQ",
    "IRELAND",
    "ISLE OF MAN",
    "ISRAEL",
    "ITALY",
    "IVORY COAST",
    "JAMAICA",
    "JAPAN",
    "JERSEY",
    "JORDAN",
    "KAZAKHSTAN",
    "KENYA",
    "KIRIBATI",
    "KOREA-NORTH",
    "KOREA-SOUTH",
    "KUWAIT",
    "KYRGYZSTAN",
    "LAOS",
    "LATVIA",
    "LEBANON",
    "LESOTHO",
    "LIBERIA",
    "LIBYA",
    "LIECHTENSTEIN",
    "LITHUANIA",
    "LUXEMBOURG",
    "MACAU",
    "MACEDONIA",
    "MADAGASCAR",
    "MALAWI",
    "MALAYSIA",
    "MALDIVES",
    "MALI",
    "MALTA",
    "MARSHALL ISLANDS",
    "MARTINIQUE (FRENCH)",
    "MAURITANIA",
    "MAURITIUS",
    "MAYOTTE",
    "MEXICO",
    "MICRONESIA",
    "MOLDOVA",
    "MONACO",
    "MONGOLIA",
    "MONTENEGRO",
    "MONTSERRAT",
    "MOROCCO",
    "MOZAMBIQUE",
    "MYANMAR",
    "NAMIBIA",
    "NAURU",
    "NEPAL",
    "NETHERLANDS",
    "NETHERLANDS ANTILLES",
    "NEW CALEDONIA (FRENCH)",
    "NEW ZEALAND",
    "NICARAGUA",
    "NIGER",
    "NIGERIA",
    "NIUE",
    "NORFOLK ISLAND",
    "NORTHERN MARIANA ISLANDS",
    "NORWAY",
    "OMAN",
    "PAKISTAN",
    "PALAU",
    "PANAMA",
    "PAPUA NEW GUINEA",
    "PARAGUAY",
    "PERU",
    "PHILIPPINES",
    "PITCAIRN ISLAND",
    "POLAND",
    "POLYNESIA (FRENCH)",
    "PORTUGAL",
    "PUERTO RICO",
    "QATAR",
    "REUNION (FRENCH)",
    "ROMANIA",
    "RUSSIA",
    "RWANDA",
    "SAINT HELENA",
    "SAINT KITTS & NEVIS ANGUILLA",
    "SAINT LUCIA",
    "SAINT PIERRE AND MIQUELON",
    "SAINT VINCENT & GRENADINES",
    "SAMOA",
    "SAN MARINO",
    "SAO TOME AND PRINCIPE",
    "SAUDI ARABIA",
    "SENEGAL",
    "SERBIA",
    "SEYCHELLES",
    "SIERRA LEONE",
    "SINGAPORE",
    "SLOVAKIA",
    "SLOVENIA",
    "SOLOMON ISLANDS",
    "SOMALIA",
    "SOUTH AFRICA",
    "SOUTH GEORGIA & SOUTH SANDWICH ISLANDS",
    "SOUTH SUDAN",
    "SPAIN",
    "SRI LANKA",
    "SUDAN",
    "SURINAME",
    "SVALBARD AND JAN MAYEN ISLANDS",
    "SWAZILAND",
    "SWEDEN",
    "SWITZERLAND",
    "SYRIA",
    "TAIWAN",
    "TAJIKISTAN",
    "TANZANIA",
    "THAILAND",
    "TOGO",
    "TOKELAU",
    "TONGA",
    "TRINIDAD AND TOBAGO",
    "TUNISIA",
    "TURKEY",
    "TURKMENISTAN",
    "TURKS AND CAICOS ISLANDS",
    "TUVALU",
    "UNITED KINGDOM",
    "USA",
    "USA MINOR OUTLYING ISLANDS",
    "UGANDA",
    "UKRAINE",
    "UNITED ARAB EMIRATES",
    "URUGUAY",
    "UZBEKISTAN",
    "VANUATU",
    "VATICAN",
    "VENEZUELA",
    "VIETNAM",
    "VIRGIN ISLANDS (BRITISH)",
    "VIRGIN ISLANDS (USA)",
    "WALLIS AND FUTUNA ISLANDS",
    "WESTERN SAHARA",
    "YEMEN",
    "ZAMBIA",
    "ZIMBABWE",
];
